<div *ngIf="isLoading" class="loading-container">
  <mat-spinner diameter="40"></mat-spinner>
</div>

<ng-container *ngIf="!isLoading">
  <app-list-items-table *ngIf="guides.length > 0 && !error; else empty">
    <tr appListTableHead>
      <th>{{ "nouns.guide" | translate }}</th>
      <th>{{ "nouns.date" | translate }}</th>
      <th></th>
    </tr>

    <tbody appListTableBody *ngFor="let item of guides" class="hovered-row">
      <tr appListTableItem class="log-line">
        <td class="text-color-default">
          <span class="guide-link">
            <img src="assets/icons/arrow.svg" alt="" class="guide-link__icon" />
            <span class="guide-link__text">
              {{ resolveLabel(item.type) }}
            </span>
          </span>
        </td>

        <td class="text-date-created-at">
          <span>{{ item.created_at | date: "dd/MM/yyyy HH:mm" }}</span>
        </td>

        <td class="guide-action-cell">
          <img
            src="assets/icons/chevron-right.svg"
            alt="Download"
            class="guide-action-icon"
            (click)="onGuideDownloadClick(item); $event.stopPropagation()"
          />
        </td>
      </tr>
    </tbody>
  </app-list-items-table>

  <div *ngIf="totalItems > ITEMS_PER_PAGE" class="table-paging-control-container">
    <lib-paging-control [page]="currentPage" [pagesTotal]="totalPages" (pageChange)="onPageChange($event)">
    </lib-paging-control>
  </div>
</ng-container>

<ng-template #empty>
  <p class="onboarding-message">
    {{ "empty-message.no-guides" | translate }}
  </p>
</ng-template>
